const fromdatainv = [{
		inputdata: "",
		title: "发票号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "input",
		width: "180px",
		lablewith: "100px",
		btx: true,
		disabled: false
	},
	{
		inputdata: "",
		title: "开票日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "dates",
		width: "180px",
		widths: "190px",
		lablewith: "120px",
		btx: true,
		disabled: false
	},
	{
		inputdata: "",
		title: "发票类型",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "select",
		width: "190px",
		options: [],
		btx: true,
		lablewith: "110px",
		disabled: false
	},
	{
		inputdata: "",
		title: "出库单号",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "100px",
		disabled: true,
	},
	{
		inputdata: "",
		title: "发票校验码",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "120px",
		disabled: false
	},
	{
		inputdata: "",
		title: "发票代码",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "90px",
		disabled: false
	},
	{
		inputdata: "",
		title: "备注",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "100px",
		disabled: false
	},
	{
		content: '发票金额默认不需要填写;<br/>但当OCR无法识别时，需要使用四要素校验;<br/>非全电且普票无需填写，非全电专票需填无税金额;<br/>全电发票均需填含税金额',
		inputdata: undefined,
		title: "发票金额",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "",
		inputtype: "numbertowCQ",
		width: "190px",
		minleft: -999999999,
		maxleft: 999999999,
		lablewith: "120px",
		disabled: true
	},

	{
		inputdata: "",
		title: "发票方向",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		options: [],
		btx: true,
		lablewith: "90px",
		disabled: true
	},
	{
		inputdata: "",
		title: "付款方",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "selectautocompleteHP",
		width: "180px",
		lablewith: "100px",
		disabledHB: true,
		inputflag: true
	},
	{
		inputdata: '',
		title: '终端医院',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: '',
		inputtype: 'selectautocompleteHB',
		width: '190px',
		disabledHB: true,
		lablewith: '120px',
		options: [],
	},
	{
		inputdata: '',
		title: '红字类型',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: '',
		inputtype: 'select',
		width: '190px',
		disabled: true,
		lablewith: '90px',
		options: [],
	},
];
export default fromdatainv;